import { render, staticRenderFns } from "./UploadPolicies.vue?vue&type=template&id=7442e305"
import script from "./UploadPolicies.vue?vue&type=script&lang=js"
export * from "./UploadPolicies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports